module.exports = new __parcel__URL__("folder-darkmode.55dfee70.svg").toString();